import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from '@app/core/okta-auth.guard';
import { AssetManagementDashboardComponent } from './asset-management-dashboard/asset-management-dashboard.component';
import { AssetManagementTableComponent } from './asset-management-table/asset-management-table.component';
import { MyRequestFormComponent } from './my-request/my-request-form/my-request-form.component';

const routes: Routes = [
  {
    path: 'asset-management',
    canActivate: [AuthGuard],
    children: [
      { path: '', component: AssetManagementDashboardComponent },
      {
        path: 'upcoming-onboarding',
        component: AssetManagementTableComponent,
      },
      {
        path: 'upcoming-offboarding',
        component: AssetManagementTableComponent,
      },
      {
        path: 'asset-allocated',
        component: AssetManagementTableComponent,
      },
      {
        path: 'damage-analytics',
        component: AssetManagementTableComponent,
      },
      {
        path: 'vendor-stats',
        component: AssetManagementTableComponent,
      },
      {
        path: 'my-request',
        component: AssetManagementTableComponent,
      },
      {
        path: 'accessories-management',
        component: AssetManagementTableComponent
      },
      {
        path: 'inventory-order',
        component: AssetManagementTableComponent
      },
      { path: 'my-request-table', redirectTo: 'asset-management-table' },
      { path: 'my-request-form', component: MyRequestFormComponent },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetManagementRoutingModule {}
